import React from "react";
import Link from "@/components/Link";
import Components from "../components";
import styles from "./coach-card.module.scss";
import Flag from "@/components/Flags/flag";
import { GetCoaches } from "@/lib/storyblok-gapi";

interface Props {
  content: GetCoaches[number]["content"];
  full_slug: string;
}

const CoachCard = (props: Props) => {
  const {
    full_slug,
    content: { name, image, nationality, location, coach_type },
  } = props;

  return (
    <Link href={`/${full_slug}`} className={styles.coachCard}>
      {image?.map((blok) =>
        React.createElement(Components(blok.component), {
          key: blok._uid,
          blok: {
            ...blok,
            ...{ aspect_ratio_mobile: "1/1", aspect_ratio_desktop: "1/1" },
          },
          className: styles.image,
        })
      )}
      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.flag}>
            <Flag country={nationality} className={styles.flagSvg} />
          </div>
          <h3 className="ef-h6 u-mb-0">{name}</h3>
        </div>
        <div className={styles.row}>
          <p className={styles.coach_type}>{coach_type}</p>
          <p className={styles.coach_timezone}>{location?.[0]?.content}</p>
        </div>
      </div>
    </Link>
  );
};

export default CoachCard;
